const puzzle = {
  id: "3452Gvd6vYDKiHJ73",
  name: "Subtracting to the other side",
  rebuses: [
    {
      clues: [
        {
          id: "417daf3a-073f-461f-9d82-e69a4d1c98b6",
          clueValues: [
            {
              value: "WQVMCSOE.png",
              id: "56860815-4bff-4909-9efe-95c23a327a5e",
              type: "image",
              style: {
                width: "calc(50% - 10px)",
                marginRight: "-5px",
              },
              subtext: "",
            },
            {
              style: {
                width: "calc(50% - 10px)",
                marginLeft: "-5px",
              },
              value: "mxDrvC0s.png",
              type: "image",
              id: "eb051392-7f41-4e5b-8314-55edcdeb9127",
              subtext: "",
            },
            {
              style: {
                width: "calc(80% - 10px)",
              },
              subtext: "",
              value: "uBfT3gXD.png",
              type: "image",
              id: "16237f29-7065-4a1c-9f98-b693e7d1a174",
            },
          ],
          helperText:
            "Voice actor playing John Price (Call of Duty Modern Warfare)",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "76a11d5b-6dbb-46fc-a358-4d9fd415f4f2",
          clueValues: [
            {
              id: "99af4c21-ad73-4dc4-916c-4ac94b466ca3",
              value: "-",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
                fontSize: "70px",
              },
            },
          ],
          helperText: "",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(10% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "1728fde1-3122-445d-b274-07d840296427",
          clueValues: [
            {
              value: "4U0LIKMY.png",
              id: "56860815-4bff-4909-9efe-95c23a327a5e",
              type: "image",
              style: {
                width: "calc(50% - 10px)",
                marginRight: "-5px",
              },
              subtext: "",
            },
            {
              style: {
                width: "calc(50% - 10px)",
                marginLeft: "-5px",
              },
              value: "E1mx338F.png",
              type: "image",
              id: "eb051392-7f41-4e5b-8314-55edcdeb9127",
              subtext: "",
            },
            {
              style: {
                width: "calc(80% - 10px)",
              },
              subtext: "",
              value: "uBfT3gXD.png",
              type: "image",
              id: "16237f29-7065-4a1c-9f98-b693e7d1a174",
            },
          ],
          helperText: "Actor playing Phil Connors (Groundhog Day)",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      id: "tt376a3-5978-4e09-9ef6-88d153c212aa",
      style: {},
      solutionInfo: {
        solvedText: "Y",
        type: "text",
        possibleSolutions: [
          {
            value: "Y",
            id: "3bd6245a-5978-4e09-9ef6-32be2eca1b28",
          },
        ],
      },
    },
    {
      clues: [
        {
          helperText:
            "What do you get when you subtract the birthday of an actor playing John Rambo from a birthday of 43rd US president?",
          clueValues: [
            {
              value: "EqcQpUpY.png",
              id: "56860815-4bff-4909-9efe-95c23a327a5e",
              type: "image",
              style: {
                width: "calc(50% - 10px)",
                marginRight: "-5px",
              },
              subtext: "",
            },
            {
              style: {
                width: "calc(50% - 10px)",
                marginLeft: "-5px",
              },
              value: "h1gatQ1g.png",
              type: "image",
              id: "eb051392-7f41-4e5b-8314-55edcdeb9127",
              subtext: "",
            },
            {
              style: {
                width: "calc(80% - 10px)",
              },
              subtext: "",
              value: "uBfT3gXD.png",
              type: "image",
              id: "16237f29-7065-4a1c-9f98-b693e7d1a174",
            },
            {
              style: {
                width: "calc(25% - 10px)",
              },
              subtext: "",
              value: "eXGkSm7J.png",
              type: "image",
              id: "3k08f29-7065-4a1c-9f98-b693e7d1a174",
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          id: "2eb98f58-fd33-45b7-8d61-25c5652d7359",
          solutionInfo: {
            type: "date",
            possibleSolutions: [
              {
                value: {
                  place: "",
                  day: "6",
                  second: "",
                  minute: "",
                  hour: "",
                  year: "1946",
                  month: "July",
                },
                id: "f2667b40-a7e8-42bd-8581-c3bdf6b7ec3b",
              },
            ],
            solvedText: "6 July 1946",
          },
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
        },
        {
          clueValues: [
            {
              type: "text",
              style: {
                fontSize: "70px",
                width: "calc(100% - 10px)",
              },
              subtext: "",
              id: "8a193f7f-13a8-40f3-808e-f4da9ea701a1",
              value: "-",
            },
          ],
          id: "8bba16e2-f0b7-4d68-9c30-5488934ae59c",
          subtext: "",
          style: {
            width: "calc(10% - 10px)",
          },
          dependsOn: [],
          clueGroup: 0,
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          helperText: "",
        },
        {
          helperText:
            "What do you get when you subtract the birthday of an actor playing John Rambo from a birthday of 43rd US president?",
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            type: "date",
            solvedText: "6 July 1946",
            possibleSolutions: [
              {
                id: "b67092e4-fe1e-42e0-ba29-6b23eb09f21d",
                value: {
                  second: "",
                  year: "1946",
                  minute: "",
                  month: "July",
                  place: "",
                  day: "6",
                  hour: "",
                },
              },
            ],
          },
          subtext: "",
          clueGroup: 0,
          clueValues: [
            {
              subtext: "",
              value: "vzTH4h4N.png",
              id: "9618894c-56d5-4f57-a634-1ced0f66bc21",
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "a6f75c76-cf72-4d03-b6e2-0cc74e5f7bcc",
        },
      ],
      id: "ggh6245a-5978-4143-40b8-978c-88d153c212aa",
      style: {},
      solutionInfo: {
        solvedText: "0",
        type: "text",
        possibleSolutions: [
          {
            value: "0",
            id: "3bd6245a-5978-4e09-9ef6-32be2eca1b28",
          },
          {
            id: "7e6f00c6-1317-4f5a-98bb-567260d8bfb1",
            value: "Zero",
          },
        ],
      },
    },
    {
      clues: [
        {
          id: "60bbff3c-a26c-46b7-a79d-e964b8e68c3f",
          clueValues: [
            {
              id: "f62c5bb4-e7bc-4264-a886-8d1f80042f60",
              value: "L",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
                fontSize: "70px",
              },
            },
          ],
          helperText: "Convert to Roman numerals and subtract",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "172055fd-175b-4cea-ba2f-f1db0eeceda3",
          clueValues: [
            {
              id: "bb8bb746-8b1d-4ddf-916c-e645a490ac45",
              value: "-",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
                fontSize: "70px",
              },
            },
          ],
          helperText: "",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(10% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "832f2509-9dc6-4e86-9fa4-4737c84c85de",
          clueValues: [
            {
              id: "3c686f7a-6888-4f8f-9f2e-9a08fe5dcb1a",
              value: "XL",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
                fontSize: "70px",
              },
            },
          ],
          helperText: "Convert to Roman numerals and subtract",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      id: "3bd6245a-5973-40b8-978c-88d153c212aa",
      style: {},
      solutionInfo: {
        solvedText: "X",
        type: "text",
        possibleSolutions: [
          {
            value: "X",
            id: "3bd6245a-5978-4e09-9ef6-32be2eca1b28",
          },
        ],
      },
    },
    {
      clues: [
        {
          id: "8a52cef6-d03c-4acc-bf8e-01398ae7dfdd",
          clueValues: [
            {
              id: "0f246363-7ba2-40c0-9c63-d76ec2c1613e",
              value: "Mm4WbcEg.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "How do you call this type of symmetry?",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(50% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      id: "4e09-9ef6-32be2-40b8-978c-88d153c212aa",
      style: {},
      solutionInfo: {
        solvedText: "Point reflection",
        type: "text",
        possibleSolutions: [
          {
            value: "Point reflection",
            id: "3bd6245a-5978-4e09-9ef6-32be2eca1b28",
          },
          {
            id: "b7b50bf2-33d8-48a3-b548-2ccdbee2ce45",
            value: "Central symmetry",
          },
        ],
      },
    },
  ],
};

export default puzzle;
